import { z } from "zod";

export const tagSchema = z.object({
  id: z.number().int(),
  name: z.string().nullable().optional(),
  color: z.string().nullable().optional(),
  isActive: z.boolean(),
  fileCount: z.number().int().optional(),
  type: z.string().optional(),
});

export const createTagRequestSchema = z.object({
  name: z.string(),
  color: z.string(),
});

export const updateTagRequestSchema = z.object({
  name: z.string().nullable().optional(),
  color: z.string(),
  isActive: z.boolean(),
});
